import { videoRoutesDefinitions } from '@/routes-definitions';

export const videoRoutes = [
  {
    path: videoRoutesDefinitions.home.path,
    name: videoRoutesDefinitions.home.name,
    component: () => import('./pages/HomePage.vue')
  },
  {
    path: videoRoutesDefinitions.homeV2.path,
    name: videoRoutesDefinitions.homeV2.name,
    component: () => import('./pages/v2/HomeV2Page.vue')
  },
  {
    path: videoRoutesDefinitions.homeNoVideos.path,
    name: videoRoutesDefinitions.homeNoVideos.name,
    component: () => import('./pages/HomeNoVideosPage.vue')
  },
  {
    path: videoRoutesDefinitions.homeInitFailed.path,
    name: videoRoutesDefinitions.homeInitFailed.name,
    component: () => import('./pages/HomeInitFailedPage.vue')
  },
  {
    path: videoRoutesDefinitions.createProject.path,
    name: videoRoutesDefinitions.createProject.name,
    component: () => import('./pages/CreateProjectPage.vue')
  },
  {
    path: videoRoutesDefinitions.createProjectV2.path,
    name: videoRoutesDefinitions.createProjectV2.name,
    component: () => import('./pages/v2/CreateProjectV2Page.vue')
  },
  {
    path: videoRoutesDefinitions.contentEditor.path,
    name: videoRoutesDefinitions.contentEditor.name,
    component: () => import('./pages/ContentEditorPage.vue')
  },
  {
    path: videoRoutesDefinitions.contentEditorV2.path,
    name: videoRoutesDefinitions.contentEditorV2.name,
    component: () => import('./pages/v2/ContentEditorV2Page.vue')
  },
  {
    path: videoRoutesDefinitions.contentEditorCustomWithSlidesV2.path,
    name: videoRoutesDefinitions.contentEditorCustomWithSlidesV2.name,
    component: () => import('./pages/v2/CustomVideoWithSlidesCreationPage.vue')
  },
  {
    path: videoRoutesDefinitions.hiwiReview.path,
    name: videoRoutesDefinitions.hiwiReview.name,
    component: () => import('./pages/HiwiReviewPage.vue')
  },
  {
    path: videoRoutesDefinitions.hiwiReviewV2.path,
    name: videoRoutesDefinitions.hiwiReviewV2.name,
    component: () => import('./pages/v2/HiwiReviewV2Page.vue')
  },
  {
    path: videoRoutesDefinitions.uploadToMyCampus.path,
    name: videoRoutesDefinitions.uploadToMyCampus.name,
    component: () => import('./pages/v2/UploadToMyCampusPage.vue')
  },
  {
    path: videoRoutesDefinitions.results.path,
    name: videoRoutesDefinitions.results.name,
    component: () => import('./pages/ResultsPage.vue')
  }
  // {
  //   path: videoRoutesDefinitions.resultsV2.path,
  //   name: videoRoutesDefinitions.resultsV2.name,
  //   component: () => import('./pages/v2/ResultsV2Page.vue')
  // }
];
